<template>
  <div>
    <div
      v-if="showModal"
      class="modal"
      :class="showModal ? 'show' : ''"
      @click.self="closeModal"
    >
      <div class="modal-content">
        <span class="close" @click="closeModal">&times;</span>
        <div class="modal-header">
          <h2>{{ modalTitle }}</h2>
        </div>
        <div class="modal-body">
          <slot>
            <b-form class="row" @change="UpdateFrais(data)">
              <div
                class="row"
                v-if="OperationType != 16 && OperationType != 17"
              >
                <div
                  class="form-group has-float-label col-xs-12 col-sm-12 col-lg-6"
                >
                  <input
                    type="number"
                    min="0"
                    class="form-control"
                    v-model="data.apport"
                  />
                  <span style="margin-left: 17px;"
                    >Votre apport personnel €</span
                  >
                </div>
                <div
                  class="form-group has-float-label col-xs-12 col-sm-12 col-lg-6"
                  v-if="OperationType == 1 || OperationType == 3"
                >
                  <input
                    type="number"
                    class="form-control"
                    v-model="data.terrain"
                  />
                  <span style="margin-left: 17px;">Terrain €</span>
                </div>
                <div
                  class="form-group has-float-label col-xs-12 col-sm-12 col-lg-6"
                  v-if="OperationType == 13 || OperationType == 14"
                >
                  <input
                    type="number"
                    class="form-control"
                    v-model="data.soulte"
                  />
                  <span style="margin-left: 17px;">Soulte €</span>
                </div>
                <div
                  class="form-group has-float-label col-xs-12 col-sm-12 col-lg-6"
                  v-if="
                    OperationType == 1 ||
                      OperationType == 2 ||
                      OperationType == 3
                  "
                >
                  <input
                    type="number"
                    class="form-control"
                    v-model="data.viabilisation"
                  />
                  <span style="margin-left: 17px;">Viabilisation €</span>
                </div>
                <div
                  class="form-group has-float-label col-xs-12 col-sm-12 col-lg-6"
                  v-if="
                    OperationType == 2 ||
                      OperationType == 3 ||
                      OperationType == 4 ||
                      OperationType == 5 ||
                      OperationType == 6 ||
                      OperationType == 7
                  "
                >
                  <input
                    type="number"
                    class="form-control"
                    v-model="data.logemet"
                  />
                  <span style="margin-left: 17px;">Logement €</span>
                </div>
                <div
                  class="form-group has-float-label col-xs-12 col-sm-12 col-lg-6"
                  v-if="
                    OperationType == 2 ||
                      OperationType == 3 ||
                      OperationType == 4 ||
                      OperationType == 5 ||
                      OperationType == 7 ||
                      OperationType == 8 ||
                      OperationType == 9 ||
                      OperationType == 10 ||
                      OperationType == 11 ||
                      OperationType == 14
                  "
                >
                  <input
                    type="number"
                    class="form-control"
                    v-model="data.traveaux"
                  />
                  <span style="margin-left: 17px;">Travaux €</span>
                </div>
                <div
                  class="form-group has-float-label col-xs-12 col-sm-12 col-lg-6"
                  v-if="
                    OperationType == 2 ||
                      OperationType == 3 ||
                      OperationType == 4 ||
                      OperationType == 5 ||
                      OperationType == 6 ||
                      OperationType == 7 ||
                      OperationType == 8
                  "
                >
                  <input
                    type="number"
                    class="form-control"
                    v-model="data.mobilier"
                  />
                  <span style="margin-left: 17px;">Mobilier €</span>
                </div>

                <div
                  class="form-group has-float-label col-xs-12 col-sm-12 col-lg-6"
                  v-if="
                    OperationType != 13 &&
                      OperationType != 14 &&
                      OperationType != 5
                  "
                >
                  <input
                    type="number"
                    class="form-control"
                    v-model="data.etablissement"
                  />
                  <span style="margin-left: 17px;"
                    >Frais d'établissement €
                  </span>
                </div>

                <div
                  class="form-group has-float-label col-xs-12 col-sm-12 col-lg-6"
                  v-if="OperationType == 13 || OperationType == 14"
                >
                  <input
                    type="number"
                    class="form-control"
                    v-model="data.crd_refinance"
                  />
                  <span style="margin-left: 17px;">CRD refinancé €</span>
                </div>

                <div
                  class="form-group has-float-label col-xs-12 col-sm-12 col-lg-6"
                  v-if="
                    OperationType == 2 ||
                      OperationType == 3 ||
                      OperationType == 6 ||
                      OperationType == 7
                  "
                >
                  <input
                    type="number"
                    class="form-control"
                    v-model="data.expertise"
                  />
                  <span style="margin-left: 17px;">Expertise €</span>
                </div>
                <div
                  class="form-group has-float-label col-xs-12 col-sm-12 col-lg-6"
                  v-if="
                    OperationType == 1 ||
                      OperationType == 3 ||
                      OperationType == 4 ||
                      OperationType == 5 ||
                      OperationType == 6 ||
                      OperationType == 7
                  "
                >
                  <input
                    type="number"
                    class="form-control"
                    v-model="data.agence"
                  />
                  <span style="margin-left: 17px;">Agence €</span>
                </div>

                <div
                  class="form-group has-float-label col-xs-12 col-sm-12 col-lg-6"
                  v-if="
                    OperationType != 12 &&
                      OperationType != 13 &&
                      OperationType != 14 &&
                      OperationType != 15 &&
                      OperationType != 16 &&
                      OperationType != 17
                  "
                >
                  <input
                    type="number"
                    class="form-control"
                    v-model="data.crd_refinance"
                  />
                  <span style="margin-left: 17px;">CRD refinancé €</span>
                </div>
                <!-- <div class="form-group has-float-label col-xs-12 col-sm-12 col-lg-6" v-if="(OperationType==1) || (OperationType==3) || (OperationType==4) || (OperationType==5) || (OperationType==6) || (OperationType==7) || (OperationType==13) || (OperationType==14)"> -->
                <div class="row col-lg-6">
                  <div
                    class="form-group has-float-label col-xs-12 col-sm-12 col-lg-9"
                    v-if="
                      OperationType == 1 ||
                        OperationType == 3 ||
                        OperationType == 4 ||
                        OperationType == 5 ||
                        OperationType == 6 ||
                        OperationType == 7 ||
                        OperationType == 13 ||
                        OperationType == 14
                    "
                  >
                    <input
                      type="number"
                      class="form-control"
                      v-model="data.notaire"
                    />
                    <span style="margin-left: 17px;">Frais notaire €</span>
                  </div>
                  <div
                    class="form-group has-float-label col-xs-12 col-sm-12 col-lg-3"
                    v-if="
                      OperationType == 1 ||
                        OperationType == 3 ||
                        OperationType == 4 ||
                        OperationType == 5 ||
                        OperationType == 6 ||
                        OperationType == 7 ||
                        OperationType == 13 ||
                        OperationType == 14
                    "
                  >
                    <span
                      class="simple-icon-reload"
                      style="margin-top: 17px;color:#33b4cd"
                      @click="
                        updateFraisNotaire(data),
                          UpdateSimulation(OperationType)
                      "
                    >
                      Fixé</span
                    >
                  </div>
                </div>
                <div
                  class="form-group has-float-label col-xs-12 col-sm-12 col-lg-6"
                >
                  <input
                    type="text"
                    class="form-control"
                    v-model="data.courtage"
                  />
                  <span style="margin-left: 17px;">Frais courtage €</span>
                </div>

                <!-- <div class="form-group has-float-label col-xs-12 col-sm-12 col-lg-6">
                      <input type="number" class="form-control"  v-model="data.viabilisation">
                      <span style="margin-left: 17px;">Frais garantie €</span>
                  </div> -->
                <div
                  class="form-group has-float-label col-xs-12 col-sm-12 col-lg-6"
                >
                  <input
                    type="number"
                    class="form-control"
                    v-model="data.couttotal"
                    disabled
                  />
                  <span style="margin-left: 17px;">Coût total €</span>
                </div>
              </div>

              <div v-else class="row">
                <div
                  class="form-group has-float-label col-xs-12 col-sm-12 col-lg-6"
                >
                  <input
                    type="number"
                    min="0"
                    class="form-control"
                    v-model="data.apport"
                  />
                  <span style="margin-left: 17px;"
                    >Votre apport personnel €
                  </span>
                </div>

                <div
                  class="form-group has-float-label col-xs-12 col-sm-12 col-lg-6"
                >
                  <input
                    type="number"
                    class="form-control"
                    v-model="data.pret_rachete"
                    :disabled="
                      OperationType == 16 ||
                        OperationType == 17 ||
                        inputsDisabled == 1
                    "
                  />
                  <span style="margin-left: 17px;">Prêt racheté €</span>
                </div>
                <div
                  class="form-group has-float-label col-xs-12 col-sm-12 col-lg-6"
                >
                  <input
                    type="number"
                    class="form-control"
                    v-model="data.decouvert_blanc"
                  />
                  <span style="margin-left: 17px;">Decouvert blanc €</span>
                </div>
                <div
                  class="form-group has-float-label col-xs-12 col-sm-12 col-lg-6"
                >
                  <input
                    type="number"
                    class="form-control"
                    v-model="data.traveaux"
                  />
                  <span style="margin-left: 17px;">Travaux €</span>
                </div>
                <div
                  class="form-group has-float-label col-xs-12 col-sm-12 col-lg-6"
                >
                  <input
                    type="number"
                    class="form-control"
                    v-model="data.indemite_ra"
                  />
                  <span style="margin-left: 17px;">Indemnité de R.A €</span>
                </div>
                <div
                  class="form-group has-float-label col-xs-12 col-sm-12 col-lg-6"
                >
                  <input
                    type="number"
                    class="form-control"
                    v-model="data.fr_leve_hypo"
                  />
                  <span style="margin-left: 17px;">Fr.levée hypo €</span>
                </div>
                <div
                  class="form-group has-float-label col-xs-12 col-sm-12 col-lg-6"
                >
                  <input
                    type="number"
                    class="form-control"
                    v-model="data.notaire"
                  />
                  <span style="margin-left: 17px;">Frais de notaire €</span>
                </div>
                <div
                  class="form-group has-float-label col-xs-12 col-sm-12 col-lg-6"
                >
                  <input
                    type="text"
                    class="form-control"
                    v-model="data.courtage"
                  />
                  <span style="margin-left: 17px;">Frais courtage €</span>
                </div>

                <div
                  class="form-group has-float-label col-xs-12 col-sm-12 col-lg-6"
                >
                  <input
                    type="text"
                    class="form-control"
                    v-model="data.tresorie"
                  />
                  <span style="margin-left: 17px;"> Trésorie €</span>
                </div>

                <div
                  class="form-group has-float-label col-xs-12 col-sm-12 col-lg-6"
                >
                  <input
                    type="number"
                    class="form-control"
                    v-model="data.couttotal"
                  />
                  <span style="margin-left: 17px;">Total à financier €</span>
                </div>
              </div>
              <template class="row mt-3">
                <div class="col-12" style="text-align: center;">
                  <b-button
                    variant="btn btn-primary Ignore"
                    @click="hideModal('cout_projet')"
                    >Fermer</b-button
                  >
                </div>
              </template>
            </b-form>
          </slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    showModal: Boolean,
    modalTitle: String,
    data: Object,
    OperationType: Number,
  },
  methods: {
    closeModal() {
      this.$emit("close-modal");
    },
  },
};
</script>

<style scoped>
/* The Modal */
.modal {
  display: none; /* Hidden by default */
  position: fixed; /* Stay in place */
  z-index: 999; /* Sit on top */
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7); /* Black with opacity */
}

.show {
  display: block !important;
}

/* Modal Content */
.modal-content {
  background-color: #fefefe;
  margin: 15% auto;
  padding: 20px;
  border: 1px solid #888;
  width: 60%;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.modal-header {
  border-bottom: 1px solid #d7d7d7;
}

/* Close Button */
.close {
  color: #aaa;
  float: right;
  font-size: 28px;
  font-weight: bold;
}

.close:hover,
.close:focus {
  color: black;
  text-decoration: none;
  cursor: pointer;
}
</style>
